
/* istanbul ignore file */

import { IScope } from '../../types';

export interface IAlertFlags {
  RejectedKeywordsCount: number;
  RejectedAdsCount: number;
  RejectedSmartCampaignAdsCount: number;
  RejectedKeywordsCountV2: number;
  RejectedAdsCountV2: number;
  RejectedSmartCampaignAdsCountV2: number;
  RejectedSmartListingsCount: number;
  RejectedAdResourceCount: number;

  HasCampaigns: boolean;
  HasNotPausedCampaigns: boolean;
  HasAdGroups: boolean;
  HasNotPausedAdGroups: boolean;
  HasAds: boolean;
  HasNotPausedAds: boolean;
  HasKeywords: boolean;
  HasNotPausedKeywords: boolean;
  HasActiveNonDefaultCampaigns: boolean;

  HasMsClickIdTaggingEnabled: boolean;
  HasGoals: boolean;
}

export const getAlertFlags = async function (select: string[], scope: IScope) {
  // @ts-ignore
  const { getEntityFromScope } = await import(/* webpackMode: 'eager' */ '@bingads-webui/edm-campaign');
  const { currentEntity } = getEntityFromScope(scope);

  const alertFlags = await currentEntity['Default.AlertInformation']
    .$makeCall({
      query: { select },
      functionParams: {},
    })
    .toPromise();

  return alertFlags;
};
